import {
  fork,
} from 'redux-saga/effects';

import rootSaga from '../views/saga';
import operatorListSaga from '../views/Business/OperatorList/saga';
import operatorNewSaga from '../views/Business/OperatorNew/saga';
import roleSaga from '../views/Role/saga';

export default function* root() {
  yield fork(rootSaga);
  yield fork(operatorListSaga);
  yield fork(operatorNewSaga);
  yield fork(roleSaga);
}



// WEBPACK FOOTER //
// ./src/store/rootSaga.js